<div class="container-lg container-xl cornerr bg-white py-2 my-2">

    <div class="row my-5">
        <div class="col-12 col-md-4">
                <img src="assets/img/quotevision.png" class="rounded w-100" />
        </div>
        <div class="col-12 col-md-4">
                <img src="assets/img/quotevision2.png" class="rounded w-100" />
        </div>
        <div class="col-12 col-md-4">
                <img src="assets/img/quotevision3.png" class="rounded w-100" />
        </div>
    </div>

    <div class="row my-5">
        <div class="col-12 col-md-3">
            
        </div>
        <div class="col-12 col-md-6">
            <img src="assets/img/AGENDA.png" class="rounded w-100" />
        </div>
        <div class="col-12 col-md-3">
            
        </div>
    </div>
    <br>
    <br>
    <div class="row my-5">
        <div class="col-12 col-md-4">
            <img src="assets/img/01.png" class="rounded w-100" />
        </div>
        <div class="col-12 col-md-4">
            <img src="assets/img/02.png" class="rounded w-100" />
        </div>
        <div class="col-12 col-md-4">
            <img src="assets/img/03.png" class="rounded w-100" />
        </div>
    </div>
    <br>
    <br>
    <div class="row my-5">
        <div class="col-12 col-md-4">
            <img src="assets/img/vision1.png" class="rounded w-100" />
        </div>
        <div class="col-12 col-md-4">
            <img src="assets/img/vision2.png" class="rounded w-100" />
        </div>
        <div class="col-12 col-md-4">
            <img src="assets/img/vision3.png" class="rounded w-100" />
        </div>
    </div>
<br>
<br><br>
<br><br>
<br><br>
<br>
</div>
